import { Loader2, CheckCircle2 } from 'lucide-react';
import { clsx } from 'clsx';
import type { ToolActivity } from '../../store';

interface ToolActivityIndicatorProps {
  activities: ToolActivity[];
  compact?: boolean;
}

export function ToolActivityIndicator({ activities, compact = false }: ToolActivityIndicatorProps) {
  if (!activities || activities.length === 0) return null;

  return (
    <div className={clsx('flex flex-col gap-1', compact ? 'mb-2' : 'mb-3')}>
      {activities.map((activity, i) => (
        <div
          key={`${activity.name}-${i}`}
          className={clsx(
            'flex items-center gap-2',
            compact ? 'text-xs' : 'text-xs sm:text-sm',
            activity.status === 'done' ? 'text-[var(--text-muted)]' : 'text-[var(--color-accent)]'
          )}
        >
          {activity.status === 'calling' ? (
            <Loader2 className={clsx('animate-spin flex-shrink-0', compact ? 'h-3 w-3' : 'h-3.5 w-3.5')} />
          ) : (
            <CheckCircle2 className={clsx('flex-shrink-0', compact ? 'h-3 w-3' : 'h-3.5 w-3.5')} />
          )}
          <span className={activity.status === 'done' ? 'line-through opacity-60' : ''}>
            {activity.displayName}...
          </span>
        </div>
      ))}
    </div>
  );
}
